module.exports = __webpack_public_path__ + "static/media/a4_parking.cb29d831.png";